import { dealerSearchResultsStore, SavedDealerCookie } from '../state/dealer-search-results-store';
import { navStateStore } from '../state/nav-state-store';
import { splitLocale } from '../entities/locale';
import { showDealerSearchDropdown } from '../utility/helper/dealer-search-helper';
import { getConfig } from '../utility/helper';
import logger from './logger';
import { getPPNDealer, getPPNDealerByRegion } from './dealer-service';

export async function loadSavedDealerSearchResults(): Promise<void> {
  const { savedDealerCookie, ppnDealers } = dealerSearchResultsStore.state;
  const { locale } = navStateStore.state;

  if (savedDealerCookie === null || ppnDealers[savedDealerCookie.id] !== undefined) {
    return;
  }

  const coordinates = { latitude: savedDealerCookie.latitude, longitude: savedDealerCookie.longitude };
  const { env } = navStateStore.state;

  try {
    const { country } = splitLocale(locale);
    const { id: dealerId } = savedDealerCookie;

    const ppnDealer = showDealerSearchDropdown(country)
      ? await getPPNDealerByRegion(dealerId, country)
      : await getPPNDealer(env, getConfig(env).DEALER_API_URL, dealerId, coordinates, country);

    dealerSearchResultsStore.state.ppnDealers[savedDealerCookie.id] = ppnDealer;
  } catch (err) {
    console.log('getPPNDealer', getPPNDealer);
    console.log('ERROR', err);
    logger.error('GET_DEALER', err as Error);
    dealerSearchResultsStore.state.savedDealerCookie = null;
  }
}

export function setDealerCookieInfo(dealer: SavedDealerCookie | null): void {
  dealerSearchResultsStore.state.savedDealerCookie = dealer;
}
